import { Navigate, useLocation } from 'react-router-dom';

export default function PublicRoute({ children }) {
  const location = useLocation();
  const token = typeof window !== 'undefined' ? localStorage.getItem('authToken') : null;
  const from = location.state?.from?.pathname || '/dashboard/default';

  if (token) {
    return <Navigate to={from} replace />;
  }

  return children;
}
